/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.OfficeOnline')
    .factory('OfficeOnline', ['$document', '$routeParams', '$rootScope', '$compile', '$location', 'relativeUrlRootFilter', function ($document, $routeParams, $rootScope, $compile, $location, relativeUrlRootFilter) {
        var
            URL_QUERY_PARAM_NAME = 'OfficeOnline',
            DIRECTIVE = 'acc-office-online-fullscreen',
            IFRAME_BASE_URL = '/web_preview/office_online.html',
            lastFile,
            opened = false,
            officeOnlineService = {
                getIframeUrl: function (file, action) {
                    var params = {};

                    params['file_action'] = encodeURIComponent(action);
                    params['uuid'] = file.uuid;

                    return relativeUrlRootFilter([IFRAME_BASE_URL, $.param(params)].join('?'));
                },
                getUrlQueryParamName: function () {
                    return URL_QUERY_PARAM_NAME;
                },
                canCreateInto: function (node) {
                    return node.office_online_permissions && node.office_online_permissions.can_create_files_into;
                },
                canPreview: function (node) {
                    return node.office_online_permissions && node.office_online_permissions.can_be_previewed;
                },
                canEdit: function (node) {
                    return node.office_online_permissions && node.office_online_permissions.can_be_edited;
                },
                setClosed: function () {
                    $rootScope.$broadcast('reload.dataTable');
                    $rootScope.$broadcast('reload.contentStats');
                    opened = false;
                },
                openFullscreen: function (file, action) {
                    var $scope = $rootScope.$new();
                    $scope.iframeUrl = this.getIframeUrl(file, action);
                    $scope.action = action;
                    $scope.file = file;

                    $document.find('body').prepend($compile($('<div></div>').attr(DIRECTIVE, ''))($scope));
                    lastFile = file;
                    opened = true;
                }
            };

        $rootScope.$on('$routeUpdate', function () {
            var urlQueryParamValue = $location.search()[officeOnlineService.getUrlQueryParamName()];
            if (urlQueryParamValue) {
                if (!opened && lastFile) {
                    officeOnlineService.openFullscreen(lastFile, urlQueryParamValue);
                }
            }
        });

        return officeOnlineService;
    }]);
